import React, { useState } from "react";

const Section3 = ({ url }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="home-section-3">
        <div className="container">

            <div className="row d-flex align-items-center justify-content-center">

            {/* Left Content */}
            <div className="col-lg-6 col-xl-5 col-md-12 content-col" data-aos="fade-right" data-aos-duration="1000">

                <div className="section-header">
                <h2>
                    Intelligent Automation for <br />
                    <span>Every Stage of Hiring</span>
                </h2>
                <p className="section-desc">
                    Stop wrestling with resume folders, spreadsheets, and email chains. Our AI recruiting software handles the heavy lifting so you can focus on what matters.
                </p>
                </div>


            </div>

            {/* Right Image */}
            <div className="col-lg-6 col-xl-5 col-md-12 image-col">
                <div className="image-wrapper" data-aos="fade-left" data-aos-duration="1000">
                <img
                    src={`${url}images/intelihire/sec-3.png`}
                    alt="AI Hiring Automation"
                    className="img-fluid"
                />
                </div>
            </div>

            </div>
        </div>
        </section>
  );
};

export default Section3;